import { Flex, Box, Nav, NavItem, IconButton, IconChevronDown } from '@flodesk/grain';

export function TopNav() {
  return (
    <Flex
      tag="header"
      height="96px"
      paddingY="28px"
      paddingX="xl"
      backgroundColor="#ffffff"
      shadow="s"
      justifyContent="space-between"
    >
      {/* Logo */}
      <Flex width="160px" alignItems="center">
        <img src="/flodesk.png" alt="Flodesk" style={{ width: 160, height: 12 }} />
      </Flex>

      {/* Navigation */}
      <Nav direction="row" size="m">
        <NavItem isActive>Emails</NavItem>
        <NavItem>Forms</NavItem>
        <NavItem>Workflows</NavItem>
        <NavItem>Checkouts</NavItem>
        <Box width="1px" height="16px" backgroundColor="rgba(55,49,47,0.2)" />
        <NavItem>Products</NavItem>
        <NavItem>Audience</NavItem>
        <NavItem>Analytics</NavItem>
      </Nav>

      {/* Profile */}
      <Flex width="160px" justifyContent="end" columnGap="s">
        <Box width="40px" height="40px" radius="l" backgroundColor="#d9d4cf" overflow="hidden" />
        <IconButton icon={IconChevronDown} variant="neutral" />
      </Flex>
    </Flex>
  );
}
